module.exports = new __parcel__URL__("hud_leaderboard_button.1410cb00.png").toString();